/* Cart page — quantity changes and removal, then a reload so every total in
   the page (line prices, subtotal, discounts) comes back from Liquid. */
(function () {
  'use strict';

  const Theme = window.MassrutineTheme || {};

  class CartPage extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
    }

    onClick(event) {
      const remove = event.target.closest('[data-cart-remove]');
      if (remove) {
        event.preventDefault();
        const item = remove.closest('[data-cart-item]');
        if (item) this.update(item, 0);
        return;
      }

      const decrease = event.target.closest('[data-quantity-decrease]');
      if (decrease) {
        this.step(decrease, -1);
        return;
      }

      const increase = event.target.closest('[data-quantity-increase]');
      if (increase) {
        this.step(increase, 1);
      }
    }

    onChange(event) {
      const input = event.target.closest('[data-quantity-input]');
      if (!input) return;

      const item = input.closest('[data-cart-item]');
      if (item) this.update(item, Math.max(0, parseInt(input.value, 10) || 0));
    }

    step(button, delta) {
      const wrapper = button.closest('[data-quantity]');
      const input = wrapper && wrapper.querySelector('[data-quantity-input]');
      if (!input) return;

      const next = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
      input.value = next;

      const item = input.closest('[data-cart-item]');
      if (item) this.update(item, next);
    }

    update(item, quantity) {
      item.classList.add('is-updating');

      Theme.CartAPI.change({ id: item.dataset.key, quantity: quantity })
        .then(function () {
          window.location.reload();
        })
        .catch(function () {
          item.classList.remove('is-updating');
        });
    }
  }

  if (!customElements.get('cart-page')) {
    customElements.define('cart-page', CartPage);
  }
})();
